/**
 * 路由组件设计思路：
 * 基础可访问的路由白名单只有无权限页面和没消息页面，异步路由组件根据后端返回的树形结构解析成路由可解析的结构，渲染在layout下。
 */


import Vue from 'vue'
import Router from 'vue-router'

import routerBase from './map/base'

Vue.use(Router)

// 路由数据
export const constantRouterMap = routerBase

// 构建基础路由
export default new Router({
  routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js